module.exports = __webpack_public_path__ + "static/6-202b14fc885abc76f40e6ee1c990a954.jpg";